<router-outlet></router-outlet>
<app-spinner></app-spinner>
<app-images-dialog></app-images-dialog>